import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface titleState {
  titleName: string;
}

const initialState: titleState = {
  titleName: '',
};

const titleSlice = createSlice({
  name: 'title',
  initialState,
  reducers: {
    setTitleName: (state, action: PayloadAction<string>) => {
      state.titleName = action.payload;
    },
  },
});

export const { setTitleName } = titleSlice.actions;

export default titleSlice.reducer;
